import script from "./FormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDialog.vue?vue&type=script&setup=true&lang=js"

import "./FormDialog.vue?vue&type=style&index=0&id=487e2c2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487e2c2a"]])

export default __exports__